<template>
    <footer class="bg-background text-gold p-4">
        <div class="container mx-auto text-center">
            <p>&copy; {{ currentYear }} Qui est le plus riche ?</p>
            <nav class="mt-2 space-x-4">
                <a href="#" class="hover:text-gold">Politique de confidentialité</a>
                <a href="#" class="hover:text-gold">Conditions d'utilisation</a>
                <a href="#" class="hover:text-gold">Contact</a>
            </nav>
        </div>
    </footer>
</template>
<script setup>
const currentYear = new Date().getFullYear();
</script>
